// extracted by mini-css-extract-plugin
export default {"LogoList":"y8oKXuYxPDutHmERyJz3"};